import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-blue py-1 px-3 text-white rounded-md w-max max-w-[250px] whitespace-nowrap text-ellipsis overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.fileName), 1),
    _createElementVNode("input", {
      type: "file",
      ref: "fileInput",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
      style: {"display":"none"},
      accept: "image/png, image/jpeg, image/webp"
    }, null, 544)
  ]))
}